import IconExclamationMarkYellow from "assets/img/icon-exclamation-mark-yellow.svg"
import IconStatusSuccess from "assets/img/icon-status-success.svg"
import IconStatusSuccessAlt from "assets/img/icon-status-success-alternative.svg"
import IconStatusNotRelevant from "assets/img/icon-times-circle.svg"
import IconStatusError from "assets/img/icon-status-error.svg"
import "./StatusLight.scss"

import { FC } from "react"

import { Grid, GridItem } from "components/Grid"
import Text from "components/Text/Text"

export enum StatusLightType {
    success = "success",
    successAlt = "successAlt",
    warning = "warning",
    notRelevant = "notRelevant",
    error = "error"
}

const StatusIcons = {
    [StatusLightType.success]: IconStatusSuccess,
    [StatusLightType.successAlt]: IconStatusSuccessAlt,
    [StatusLightType.warning]: IconExclamationMarkYellow,
    [StatusLightType.notRelevant]: IconStatusNotRelevant,
    [StatusLightType.error]: IconStatusError
}

interface IStatusLightProps {
    type: StatusLightType
}

const StatusLight: FC<React.PropsWithChildren<IStatusLightProps>> = ({
    type,
    children,
    ...others
}) => {
    return (
        <Grid columns="max-content auto" gap={children ? "0.8rem" : undefined} className={`status-light status-light--type-${type}`}>
            <GridItem alignSelf="center">
                <img src={StatusIcons[type]} className="d-block" alt="" />
            </GridItem>
            <GridItem alignSelf="center">
                <Text type="pSmallest">
                    {children}
                </Text>
            </GridItem>
        </Grid>
    )
}

export default StatusLight
